import { SET_BILLIING_STATES__DATA, SET_BILLIING_SUMMRAY__DATA, SET_BILLING_MEMBERSHIP_DATA, SET_BILLING_PACKAGE_DATA, SET_BILLING_PRODUCTS_DATA, SET_BILLING_SERVICES_DATA, SET_COUPON__DATA, SET_CLIENT_DATA, SET_PAYMENT_METHOD__DATA } from "../ActionName/ActionName"

export const setServicesJson = (data) => {
    return {
        type: SET_BILLING_SERVICES_DATA,
        value: data
    }
}

export const setClientData = (data) => {
    return {
        type: SET_CLIENT_DATA,
        value: data
    }
}
export const setProductJson = (data) => {
    return {
        type: SET_BILLING_PRODUCTS_DATA,
        value: data
    }
}
export const setMemberShipJson = (data) => {
    return {
        type: SET_BILLING_MEMBERSHIP_DATA,
        value: data
    }
}
export const setPackageJson = (data) => {
    return {
        type: SET_BILLING_PACKAGE_DATA,
        value: data
    }
}

export const setCouponJson = (data) => {
    return {
        type: SET_COUPON__DATA,
        value: data
    }
}

export const setBillingStates = (data) => {
    return {
        type: SET_BILLIING_STATES__DATA,
        value: data
    }
}


export const setPaymentMethod = (data) => {
    return {
        type: SET_PAYMENT_METHOD__DATA,
        value: data
    }
}


// export const setUserData = (data) => {
//     return {
//         type: SET_USER_DATA,
//         value: data
//     }
// }